import { DraggableAttributes } from "@dnd-kit/core";
import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { createContext, useContext } from "react";

import { IRideDto, IStationRideProps } from "@ryde/shared";

import { IUseRideStation } from "./hooks-context-providers";

export interface IRideStationContext
  extends Partial<IUseRideStation>, Partial<IStationRideProps> {
  rideDto?: IRideDto;
  isDragging: boolean;
  listeners?: SyntheticListenerMap;
  attributes?: DraggableAttributes;
  isStationDraggable?: boolean;
}
export const RideStationContext = createContext<IRideStationContext>({
  rideDto: undefined,
  isDragging: false,
});
export const useRideStationContext = (): IRideStationContext =>
  useContext(RideStationContext);
